import React from 'react'

import { logoutUser } from 'store/auth/actions'
import { useDispatch } from 'store/hooks'
import { storage } from 'utils'

import { Stack, Typography } from '@mui/material'
import { Button } from '@repo/ui'

interface LogOutProps {
  handleClose: () => void
}

export const LogOut = ({ handleClose }: LogOutProps) => {
  const dispatch = useDispatch()

  const logout = () => {
    storage.removeItem('accessToken')
    storage.removeItem('refreshToken')
    storage.removeItem('scanToken')
    dispatch(logoutUser())
  }

  return (
    <>
      <Typography variant="body1" sx={{ textAlign: 'center' }}>
        Are you sure you want to log out?
      </Typography>
      <Stack gap="12px" mt={3}>
        {/*
          VERA-837: NOT destructive. §32's "committed surface" tier assumes the
          confirm is irreversible — logging out isn't. Nothing is lost and you
          just log back in. Red here spends the danger signal on a safe action,
          which weakens it where it actually matters (delete, cancel, transfer).
          Refines the VERA-291 read: transient-and-engaged is necessary but not
          sufficient for red; the action must also be hard to undo.
        */}
        <Button fullWidth variant="primary" onClick={logout}>
          Log out
        </Button>
        <Button fullWidth variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Stack>
    </>
  )
}
